<template>
  <div>
    <div class="popup-toast">
      <b-alert
        fade
        class="position-fixed fixed-bottom"
        :show="open && message.text != ''"
        variant="danger"
      >
        <b-row>
          <font-awesome-icon
            :icon="['fa', 'times']"
            class="close"
            @click="hideModal"
          />
          <b-col cols="1">
            <font-awesome-icon
              :icon="['fa', 'info-circle']"
              class="text-danger fs-18"
          /></b-col>
          <b-col cols="11">
            <h6 class="mb-2 fs-14" v-html="message.text" />
            <span
              class="fs-12"
              v-if="message.type == 'logout' || message.type == 'orderPos'"
            >
              <b-link
                @click="
                  hideModal(
                    message.type == 'orderPos' ? 'orderUnav' : 'session'
                  )
                "
                >Click here
              </b-link>
              <span v-html="message.info" />
            </span>
            <span class="fs-12" v-else>
              <span v-html="message.info" />
            </span>
          </b-col>
        </b-row>
      </b-alert>
      <!-- <b-modal
      size="sm"
      ref="show-meesage-box"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      @hidden="hideModal"
    >
      <div class="message-body">
        <p class="mt-10 mb-0" v-html="message.text" id="message"></p>
      </div>
      <template slot="modal-footer">
        <div class="message-footer">
          <b-button @click="logout" variant="success" id="message-btn">{{
            message.btnText
          }}</b-button>
        </div>
      </template>
    </b-modal> -->
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  name: "message-box",
  props: {
    open: { default: false, type: Boolean },
    message: "",
  },
  // computed: {
  //   ...mapState({
  //     state: (state) => state,
  //   }),
  // },
  // watch: {
  //   open() {
  //     if (this.open) {
  //       console.log("[MessageBox] : Open");
  //     } else {
  //       console.log("[MessageBox] : Close");
  //     }
  //   },
  // },
  methods: {
    logout() {
      // this.$refs["show-meesage-box"].hide();
      //   if (this.state.message.type == "logout") {
      //     this.$store.dispatch("logout").then(() => {
      //       this.$router.push("/");
      //     });
      //   }
      //   this.$store.commit("clearMessage");
    },
    hideModal(type) {
      if (type == "session") this.$emit("close-message", "session");
      else if (type == "orderUnav") this.$emit("close-message", "orderUnav");
      else this.$emit("close-message", false);
    },
  },
};
</script>
